import { useState, useEffect } from "react";
import * as Comp from "../../../common/CommonComponents";

const PTicketDetailInfoTable = (props) => {
  const [tableData, setTableData] = useState([]);
  const [writeAuthority, setWriteAuthority] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (props.data !== undefined) {
      setTableData(props.data);
    }
    if (props.actionPermission !== undefined) {
      setWriteAuthority(props.actionPermission.WRITE === "Y");
    }
  }, [props.data]);

  // function checkBoxHandler(row, val, featureType) {
  //   const newData = [...tableData];
  //   const no = newData[row.rowNo].PERMISSION_DETAILS.filter(
  //     (d) => d.FEATURE_TYPE === featureType
  //   ).map((f) => f.rowNo)[0];

  //   try {
  //       if (featureType !== "R" && val === true) {
  //       const detailR = newData[row.rowNo].PERMISSION_DETAILS.filter(
  //         (d) => d.FEATURE_TYPE === "R"
  //       );
  //       if (
  //         detailR.length > 0 &&
  //         newData[row.rowNo].PERMISSION_DETAILS[detailR[0].rowNo].AUTHORIZED ===
  //           "N"
  //       ) {
  //         var featureIdR = row.PERMISSION_DETAILS[detailR[0].rowNo].MODULE_FEATURE_ID;
  //         props.ChangeFeaturePermission(featureIdR, val);
  //         newData[row.rowNo].PERMISSION_DETAILS[detailR[0].rowNo].AUTHORIZED =
  //           val === true ? "Y" : "N";
  //       }
  //       if (newData[row.rowNo].key === "Access") {
  //         const detailW = newData[row.rowNo].PERMISSION_DETAILS.filter(
  //           (d) => d.FEATURE_TYPE === "W"
  //         );
  //         if (detailW.length > 0 &&
  //           newData[row.rowNo].PERMISSION_DETAILS[detailW[0].rowNo].AUTHORIZED ===
  //             "N") {
  //           const nonAccess = newData.filter((d) => d.key !== "Access");
  //           nonAccess.forEach((data) => {  
  //             const detailW = data.PERMISSION_DETAILS.filter(
  //               (d) => d.FEATURE_TYPE === "W"
  //             );
  //             var featureIdW = data.PERMISSION_DETAILS[detailW[0].rowNo].MODULE_FEATURE_ID;
  //             console.log(detailW)
  //             props.ChangeFeaturePermission(featureIdW, val);
  //             newData[data.rowNo].PERMISSION_DETAILS[detailW[0].rowNo].AUTHORIZED =
  //             val === true ? "Y" : "N";
  //           })
  //         }
  //       }
  //     }
  //     var featureId = row.PERMISSION_DETAILS[no].MODULE_FEATURE_ID;
  //     props.ChangeFeaturePermission(featureId, val);
  //     newData[row.rowNo].PERMISSION_DETAILS[no].AUTHORIZED =
  //       val === true ? "Y" : "N";
      
  //   } finally {
  //     setTableData([...newData]);
  //   }
  // }

  function checkBoxHandler (row, val, featureType) {
    const newData = [...tableData];
    const no = newData[row.rowNo].PERMISSION_DETAILS.filter((d) => d.FEATURE_TYPE === featureType).map((f) => f.rowNo)[0];

    try {
          if (newData[row.rowNo].key === "Access") {
            if (featureType !== "R" && val === true) {
              const detailR = newData[row.rowNo].PERMISSION_DETAILS.filter((d) => d.FEATURE_TYPE === "R");
              if (detailR.length > 0 && newData[row.rowNo].PERMISSION_DETAILS[detailR[0].rowNo].AUTHORIZED === "N") {
                var featureIdR = row.PERMISSION_DETAILS[detailR[0].rowNo].MODULE_FEATURE_ID;
                props.ChangeFeaturePermission(featureIdR, val);
                newData[row.rowNo].PERMISSION_DETAILS[detailR[0].rowNo].AUTHORIZED = val === true ? "Y" : "N";
              }

              const nonAccess = newData.filter((d) => d.key !== "Access")
              nonAccess.map((data) => {
                const key = data.key;
                setDisabled((prevState) => ({
                  ...prevState,
                  [key] : false,
                }));
              })
              nonAccess.forEach((data) => {
                const nonAccessW = newData[data.rowNo].PERMISSION_DETAILS.filter((d) => d.FEATURE_TYPE === "W");
                if (nonAccessW.length > 0 && newData[data.rowNo].PERMISSION_DETAILS[nonAccessW[0].rowNo].AUTHORIZED === "N") {
                  var featureIdW = data.PERMISSION_DETAILS[nonAccessW[0].rowNo].MODULE_FEATURE_ID;
                  props.ChangeFeaturePermission(featureIdW, val);
                  newData[data.rowNo].PERMISSION_DETAILS[nonAccessW[0].rowNo].AUTHORIZED = val === true ? "Y" : "N";
                }
              })
            } 
            if (featureType !== "R" && val === false) {
              const nonAccess = newData.filter((d) => d.key !== "Access")
              nonAccess.map((data) => {
                const key = data.key;
                setDisabled((prevState) => ({
                  ...prevState,
                  [key] : true,
                }));
              })
              nonAccess.forEach((data) => {
                const nonAccessW = newData[data.rowNo].PERMISSION_DETAILS.filter((d) => d.FEATURE_TYPE === "W");
                if (nonAccessW.length > 0 && newData[data.rowNo].PERMISSION_DETAILS[nonAccessW[0].rowNo].AUTHORIZED === "Y") {
                  var featureIdW = data.PERMISSION_DETAILS[nonAccessW[0].rowNo].MODULE_FEATURE_ID;
                  props.ChangeFeaturePermission(featureIdW, val);
                  newData[data.rowNo].PERMISSION_DETAILS[nonAccessW[0].rowNo].AUTHORIZED = val === true ? "Y" : "N";
                }
              })
            }
          } 
          // else {
          //   const access = newData.filter((d) => d.key === "Access")
          //   const accessW = access[0].PERMISSION_DETAILS.filter((d) => d.FEATURE_TYPE === "W");
            
          //   // if (featureType !== "R" && val === true) {
          //   //   const detailR = newData[row.rowNo].PERMISSION_DETAILS.filter((d) => d.FEATURE_TYPE === "R");
          //   //   if (detailR.length > 0 && newData[row.rowNo].PERMISSION_DETAILS[detailR[0].rowNo].AUTHORIZED === "N") {
          //   //     var featureIdR = row.PERMISSION_DETAILS[detailR[0].rowNo].MODULE_FEATURE_ID;
          //   //     props.ChangeFeaturePermission(featureIdR, val);
          //   //     newData[row.rowNo].PERMISSION_DETAILS[detailR[0].rowNo].AUTHORIZED = val === true ? "Y" : "N";
          //   //   }
          //   // }
          // }     

          if (row.key === "Access") {
            var featureId = row.PERMISSION_DETAILS[no].MODULE_FEATURE_ID;
            props.ChangeFeaturePermission(featureId, val);
            newData[row.rowNo].PERMISSION_DETAILS[no].AUTHORIZED = val === true ? "Y" : "N";
          } else {
              const access = newData.filter((d) => d.key === "Access")
              const accessW = access[0].PERMISSION_DETAILS.filter((d) => d.FEATURE_TYPE === "W");

              if (accessW.length > 0 && newData[access[0].rowNo].PERMISSION_DETAILS[accessW[0].rowNo].AUTHORIZED === "Y") {
                var featureId = row.PERMISSION_DETAILS[no].MODULE_FEATURE_ID;
                props.ChangeFeaturePermission(featureId, val);
                newData[row.rowNo].PERMISSION_DETAILS[no].AUTHORIZED = val === true ? "Y" : "N";
              }
          }    
        } finally {
          setTableData([...newData]);
        }
  }

  //#region Table Columns
  const columns = [
    {
      accessorKey: "FEATURE_DESC",
      header: "Feature",
      size: 200,
    },
    {
      id: "FEATURE_TYPE_1",
      header: "Read",
      size: 60,
      accessorFn: (row) => {
        const detailR = row.PERMISSION_DETAILS.filter(
          (d) => d.FEATURE_TYPE === "R"
        );
        const detailW = row.PERMISSION_DETAILS.filter(
          (d) => d.FEATURE_TYPE === "W"
        );
        const existFlagR =
          row.PERMISSION_DETAILS.length > 0 ? detailR.length > 0 : false;
        const existFlagW =
          row.PERMISSION_DETAILS.length > 0 ? detailW.length > 0 : false;
        return (
          <>
            <Comp.Input
              id={`${row.FEATURE_DESC}_FEATURE_TYPE_1`}
              name="READ"
              type="checkbox"
              className=""
              disabled={
                !existFlagR ||
                (existFlagW ? detailW[0].AUTHORIZED === "Y" : false) ||
                !writeAuthority
              }
              checked={existFlagR ? detailR[0].AUTHORIZED === "Y" : false}
              onChange={(e) => checkBoxHandler(row, e.target.checked, "R")}
            />
          </>
        );
      },
    },
    {
      id: "FEATURE_TYPE_2",
      header: "Write",
      size: 60,
      accessorFn: (row) => {
        const detail = row.PERMISSION_DETAILS.filter(
          (d) => d.FEATURE_TYPE === "W"
        );
        const existFlag =
          row.PERMISSION_DETAILS.length > 0 ? detail.length > 0 : false;
        
        return (
          <>
            <Comp.Input
              id={`${row.FEATURE_DESC}_FEATURE_TYPE_2`}
              name="WRITE"
              type="checkbox"
              className=""
              disabled = { existFlag ? disabled[`${row.FEATURE_DESC}`] : false || !writeAuthority}
              // disabled={ !existFlag || !writeAuthority}
              checked={existFlag ? detail[0].AUTHORIZED === "Y" : false}
              onChange={(e) => checkBoxHandler(row, e.target.checked, "W")}
            />
          </>
        );
      },
    },
  ];
  //#endregion

  return (
    <>
      <Comp.VirtualTable
        columns={columns}
        data={tableData}
        enableRowSelection={false}
      />
    </>
  );
};

export default PTicketDetailInfoTable;
